import { useRef } from 'react';
import { useCanvasState } from './useCanvasState';
import { useCanvasOperations } from './useCanvasOperations';
import { useCanvasInit } from './useCanvasInit';
import { useCanvasSave } from './useCanvasSave';

export const useCanvas = (props = {}) => {
  const { saveImageParams = {}, canvasInitParams } = props || {};

  const canvasRef = useRef(null);
  const canvasState = useCanvasState();
  const canvasOperations = useCanvasOperations({canvasState, canvasRef});
  const { resetCanvas } = useCanvasInit({canvasState, canvasRef, canvasOperations, canvasInitParams});
  const { saveImage } = useCanvasSave({canvasState, canvasRef, saveImageParams});

  const canvasStyle = canvasState.isTextRegim ? {
    style: { cursor: 'text' }
  } : {};

  return {
    canvasRef,
    canvasState,
    canvasOperations,
    saveImage,
    resetCanvas,
    canvasStyle
  };
};